export default "__VITE_ASSET__BX6HVa2p__"